
import React from "react";
import { Input } from "@/components/ui/input";

interface SubmissionSearchProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

const SubmissionSearch = ({ searchTerm, setSearchTerm }: SubmissionSearchProps) => {
  return (
    <div className="w-full sm:w-80">
      <Input
        placeholder="Search submissions..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};

export default SubmissionSearch;
